module.exports = `${require.publicPath}icon09.e9a3829e.png`;